<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('tiff-to-jpg-converter', 'TIFF → JPG');

// Merge base config with TIFF→JPG specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.tiff-to-jpg',
  labels: {
    dropzoneHeading: 'Drop TIFF Files Here',
    emptyQueueMessage: 'Drop TIFF files to start your first conversion.',
    statsLabel: 'Median TIFF → JPG time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files...',
  },
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[TIFF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TIFF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TIFF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TIFF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TIFF Converter] Credits updated:', credits);
}
</script>
